import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-white py-6 md:py-8 px-4 text-center" data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <span className="inline-block bg-blue-100 text-blue-800 text-sm font-bold px-3 py-1 rounded-full mb-2 uppercase tracking-wide" data-id="element-212">
          La Solución
        </span>

        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-2" data-id="element-213">
          KIT COMPLETO PSICOLOGÍA LISTA
        </h2>

        <p className="text-xl text-gray-600 mb-4 max-w-2xl mx-auto" data-id="element-214">
          Sistema integral de clases, actividades, proyectos y evaluaciones
          diseñadas para secundaria.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6" data-id="element-215">
          {['Listo', 'Probado', 'Organizado', 'Aplicable'].map(item => <div key={item} className="flex items-center gap-2 bg-green-50 px-4 py-2 rounded-lg border border-green-100" data-id="element-216">
              <div className="bg-green-500 rounded-full p-1" data-id="element-217">
                <Check className="w-3 h-3 text-white" strokeWidth={4} data-id="element-218" />
              </div>
              <span className="font-bold text-gray-800" data-id="element-219">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}